export default __webpack_public_path__ + "static/media/TV - 2.2741c292.png";